<ng-template [ngIf]="loggedIn">
    <nb-layout>
        <nb-layout-header fixed>
            <app-header [style.width]="'100%'"></app-header>
        </nb-layout-header>
        <nb-layout-column>
            <div>
                <router-outlet></router-outlet>
            </div>
        </nb-layout-column>
    </nb-layout>
</ng-template>
